import { ReactElement } from 'react';
import { TFunction } from 'i18next';
import { capitalize } from 'lodash';
import { FileOutlined } from '@ant-design/icons';
import EuFlagIcon from 'components/icons/EuFlag';
import IrelandFlagIcon from 'components/icons/IrelandFlag';
import UkFlagIcon from 'components/icons/UkFlag';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { enumToText } from 'core/utils/enum-to-text';

const iconStyle: React.CSSProperties = {
    width: 24,
    height: 24,
};

export const countryIconMap: Record<DeclarationCountry, ReactElement> = {
    [DeclarationCountry.EU]: <EuFlagIcon style={iconStyle} />,
    [DeclarationCountry.IRELAND]: <IrelandFlagIcon style={iconStyle} />,
    [DeclarationCountry.UK]: <UkFlagIcon style={iconStyle} />,
};

export const getDeclarationCountryFlag = (declarationCountry: DeclarationCountry | undefined) => {
    if (!declarationCountry) return null;
    return countryIconMap[declarationCountry] ?? <FileOutlined />;
};

export const getDeclarationsDashboardPageTitle = (
    type: DeclarationInternalType | undefined,
    country: DeclarationCountry | undefined,
    t: TFunction
) => {
    if (!type) return '';

    if (type === DeclarationInternalType.GVMS) {
        return 'Goods Movement Records';
    }

    if (type === DeclarationInternalType.PBN) {
        return 'Pre-Boarding Notifications';
    }

    if (type === DeclarationInternalType.ENS && country === DeclarationCountry.EU) {
        return 'ENS (ICS2)';
    }

    if (type === DeclarationInternalType.ARRIVAL_NOTIFICATION_ICS2) {
        return 'Arrival Notification (ICS2)';
    }

    return `${t(type)} ${t('declarations')}`;
};

export const getCreateDeclarationButtonTitle = (
    type: DeclarationInternalType | undefined,
    country: DeclarationCountry | undefined
) => {
    if (type === DeclarationInternalType.ENS && country === DeclarationCountry.EU) {
        return 'Create ENS';
    }

    if (type === DeclarationInternalType.ARRIVAL_NOTIFICATION_ICS2) {
        return 'Create Arrival Notification';
    }

    if (type === DeclarationInternalType.GVMS) {
        return 'Create Goods Movement Record';
    }

    if (type === DeclarationInternalType.PBN) {
        return 'Create Pre-Boarding Notification';
    }

    return `Create ${capitalize(country!)} ${enumToText(type)} Declaration`;
};
